/**
 * @module support/state-object-hash-utilities
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

export class State {
  /**
   * Stores the Object value for keyValueStores
   */
  public keyValueStores: Object;

  /**
   * Stores the Object value for ttlStores
   */
  public ttlStores: Object;

  /**
   * Stores the Object value for singleUseStores
   */
  public singleUseStores: Object;

  /**
   * Stores the Object value for listeners
   */
  public listeners: Object;

  constructor() {
    this.keyValueStores = {};
    this.ttlStores = {};
    this.singleUseStores = {};
    this.listeners = {};
  }
}
